import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';

import { OfflineBanner } from '../components/OfflineBanner';

import Header from './components/Header';
import Sidebar from './components/Sidebar';

const AdminLayout: React.FC = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <div className="flex h-screen bg-default-50">
      <Sidebar
        collapsed={sidebarCollapsed}
        mobileOpen={mobileMenuOpen}
        onClose={closeMobileMenu}
        onToggleCollapse={toggleSidebar}
      />

      <main className="flex-1 flex flex-col overflow-hidden transition-all duration-300">
        <Header
          onToggleSidebar={toggleSidebar}
          onToggleMobileMenu={toggleMobileMenu}
          sidebarCollapsed={sidebarCollapsed}
        />

        <div className="flex-1 p-6 overflow-y-auto bg-content1 m-4 rounded-lg shadow-sm border border-default-200">
          {/* Connectivity first: it invalidates everything below it. */}
          <OfflineBanner />
          <Outlet />
        </div>
      </main>

      {/* Mobile overlay */}
      {mobileMenuOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-[1040] lg:hidden"
          onClick={closeMobileMenu}
        />
      )}
    </div>
  );
};

export default AdminLayout;
